module.exports = __webpack_public_path__ + "static/media/Reservations-Square.9b2119b4.jpg";